"use client";

import { parseAsString } from "nuqs";

export const parseAsSearchStringClient = parseAsString.withDefault("");
